import { RayAnnotationType } from 'Constants/EAnnotationType';

export class EllipseInfo {
    constructor() {
        this.AnnotationType = RayAnnotationType.ELLIPSE_AnnotationType;
        this.ObjectBrushHex = "#FF0066CC";
        this.LineWidth = 2;
        this.Opacity = 100;
    }
}
